import React from "react";
import "./ConfromationModal.css";
import warning from "../../Assets/warning.svg";

const ConfromationModal = ({ onClose, onConfirm }) => {
  return (
    <div className="modal-overlay">
      <div className="confirmation-modal">
        <div className="warning-icon">
          <img src={warning} alt="Warning" />
        </div>
        <p>Are you sure to reject the Application?</p>
        <div className="modal-footer">
          <button className="confirm-button" onClick={onConfirm}>Yes</button>
          <button className="cancel-button" onClick={onClose}>No</button>
        </div>
      </div>
    </div>
  );
};

export default ConfromationModal;
